import type { Chord } from 'svguitar';

export const EChords: Record<string, Chord> = {
  E: {
    fingers: [
      [1, 0],
      [2, 0],
      [3, 1, '1'],
      [4, 2, '3'],
      [5, 2, '2'],
      [6, 0, { color: 'blue', className: 'blue' }],
    ],
    barres: [],
    title: 'E',
    position: 0,
  },
  E7: {
    fingers: [
      [1, 0],
      [2, 3, '4'],
      [3, 1, '1'],
      [4, 0],
      [5, 2, '2'],
      [6, 0, { color: 'blue', className: 'blue' }],
    ],
    barres: [],
    title: 'E7',
    position: 0,
  },
  E9: {
    fingers: [
      [1, 0],
      [2, 0],
      [3, 1, '1'],
      [4, 4, '4'],
      [5, 2, '2'],
      [6, 0, { color: 'blue', className: 'blue' }],
    ],
    barres: [],
    title: 'E9',
    position: 0,
  },
  'E/G#': {
    fingers: [
      [1, 'x'],
      [2, 5, '4'],
      [3, 4, '3'],
      [4, 2, '1'],
      [5, 'x'],
      [6, 4, { text: '2', color: 'blue', className: 'blue' }],
    ],
    barres: [],
    title: 'E/G#',
    position: 0,
  },
  Em: {
    fingers: [
      [1, 0],
      [2, 0],
      [3, 0],
      [4, 2, '2'],
      [5, 2, '1'],
      [6, 0, { color: 'blue', className: 'blue' }],
    ],
    barres: [],
    title: 'Em',
    position: 0,
  },
  Em7: {
    fingers: [
      [1, 0],
      [2, 3, '3'],
      [3, 0],
      [4, 2, '2'],
      [5, 2, '1'],
      [6, 0, { color: 'blue', className: 'blue' }],
    ],
    barres: [],
    title: 'Em7',
    position: 0,
  },
};
